import React from "react";
import Header2 from "./../Common/Header3";
import Footer2 from "./../Common/Footer2";
import SEOBanner from "./../Elements/SEO/SEOBanner";
import SEOAbout from "./../Elements/SEO/SEOAbout";
import SEOWhyChooseUs from "./../Elements/SEO/SEOWhyChooseUs";
import SEOServices from "./../Elements/SEO/SEOServices";
import SEOService from "./../Elements/SEO/SEOService";
import SEOFAQ from "./../Elements/SEO/SEOFAQ";
import SEOBrand from "./../Elements/SEO/SEOBrand";
import SEOEnquiry from "./../Elements/SEO/SEOEnquiry";
import SEOAssist from "./../Elements/SEO/SEOAssist";
import SEOWhyus from "./../Elements/SEO/SEOWhyus";
import SEOOnline from "./../Elements/SEO/SEOOnline";
import Testimonials from "./../Elements/Testimonials";
import { Helmet } from "react-helmet";

class Service1 extends React.Component {
  render() {
    return (
      <>
        <Helmet>
          <title>Expert Search Engine Optimization Services | SEO</title>
          <meta
            name="description"
            content="Boost your online presence with expert Search Engine Optimization, Search Engine Marketing, and Organic Search Optimization services from Shadow infosystem. Achieve top search rankings today!"
          />
          <meta
            name="keywords"
            content="SEO services provider company, Best SEO Services Provider, Best SEO Services Company, Best SEO Services Agency"
          />
          <link
            rel="canonical"
            href="https://www.shadowinfosystem.com/search-engine-optimization"
          />
        </Helmet>
        <Header2 />
        <div className="page-content">
          <SEOBanner />
          <SEOAbout />
          <SEOEnquiry />
          <SEOServices />
          <SEOAssist />
          <SEOOnline />
          <SEOService />
          <SEOWhyChooseUs />
          <SEOBrand />
          <SEOWhyus />
          <Testimonials />
          <SEOFAQ />
        </div>

        <Footer2 />
      </>
    );
  }
}

export default Service1;
